module.exports = __webpack_public_path__ + "img/dental2_7-8-2021.f98f3a09.jpg";